module.exports = __webpack_public_path__ + "img/confirmed_cn.0f17bee8.png";